import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "../../utils/toast";
import { today } from "../../utils/excel";
import { errorMessageOf } from "../../api/scholarships";
import { Container, PageHeader, Select, Table } from "../ui";
import { BURSARIES_KEY, useStudyAreaOptions, useYearState } from "../bursaries/shared";
import { GRANTED_COLUMNS, GRANTED_EXPORT_COLUMNS, GRANTED_FILTERS } from "./grantedColumns";

/**
 * A year's granted bursary students from `list(params)`, in one study area or all, with what BRD
 * needs to pay them. HEC sees every institution, the HLI admin their own.
 */
export default function GrantedStudentsPage({ list, scope, subtitle }) {
  const [year, setYear, years] = useYearState();
  const [studyArea, setStudyArea] = useState("");
  const studyAreas = useStudyAreaOptions();
  const yearName = years.find((y) => y.value === year)?.label ?? "";

  const { data: students = [], isPending } = useQuery({
    queryKey: [BURSARIES_KEY, "granted", scope, year, studyArea],
    enabled: Boolean(year),
    staleTime: 2 * 60 * 1000,
    queryFn: async () => {
      try {
        return (await list({ academicYearId: year, ...(studyArea && { studyArea }) })).data;
      } catch (error) {
        console.error("Failed to fetch granted students:", error);
        toast.error(errorMessageOf(error, "Failed to fetch granted students."), { id: "granted-students-error" });
        throw error;
      }
    },
  });

  return (
    <Container className="flex flex-col gap-6 py-6">
      <PageHeader title="Granted Students" subtitle={subtitle} />
      <Table cardView viewKey="granted-students"
        columns={GRANTED_COLUMNS}
        filterBy={GRANTED_FILTERS}
        exportColumns={GRANTED_EXPORT_COLUMNS}
        data={students}
        isLoading={isPending && Boolean(year)}
        searchPlaceholder="Search by name, reg number, ID or email"
        exportName={`Granted_Students_${(studyArea || "All").replace(/\s+/g, "_")}_${yearName.replace(/\W+/g, "_")}_${today()}`}
        emptyTitle="No granted students found"
        filters={
          <>
            <Select aria-label="Study area" placeholder="All study areas" value={studyArea} onChange={(e) => setStudyArea(e.target.value)} options={studyAreas} className="w-full sm:w-52" />
            <Select aria-label="Academic year" value={year} onChange={(e) => setYear(e.target.value)} options={years} className="w-full sm:w-52" />
          </>
        }
      />
    </Container>
  );
}
